import { render } from "./ImprovementTables.vue?vue&type=template&id=0366db68&scoped=true"
import script from "./ImprovementTables.vue?vue&type=script&lang=js"
export * from "./ImprovementTables.vue?vue&type=script&lang=js"

import "./ImprovementTables.vue?vue&type=style&index=0&id=0366db68&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0366db68"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QField from 'quasar/src/components/field/QField.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading,QField,QTable});
